export default __webpack_public_path__ + "static/headshot-36586d929658e266081b9ee48228aaba.jpeg";